import {
} from "react";
import {
    Image,
    View
} from "react-native";
import {
    type FooterVersionInfoProps
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import packageJson from "../../../package.json";
import logo from "../../assets/images/gmmini.png";

const FooterVersionInfo = ({
    isProfile = true
}: FooterVersionInfoProps) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    return <View
        style={[
            stylesheet.container
        ]}
    >
        {isProfile && (
            <Text
                style={[
                    stylesheet.text,
                    {
                        marginBottom: spaces.spacingMd
                    }
                ]}
                variant="bodyMediumSize"
                color="low"
            >
                {localize("profileInfoVisible")}
            </Text>)}
        <Image
            source={logo}
            style={[
                stylesheet.image,
                {
                    marginBottom: spaces.spacingMd
                }
            ]}
        />
        <Text
            variant="bodyMediumSize"
            color="low"
            style={{
                marginBottom: spaces.spacingMd
            }}
        >
            {`v${packageJson.version} Genç MÜSİAD`}
        </Text>
    </View>;
};
export default FooterVersionInfo;
